/*jshint -W040, -W117 */
(function () {
    'use strict';

    angular.module('app.user')
        .component('userOrganization', {
            bindings: {
                readOnly: '<',
                model: '<',
                existingModel: '<',
                onAddressChanged: '&'
            },
            controller: userOrganizationController,
            controllerAs: 'vm',
            templateUrl: 'app/user/profile/user-organization/user.organization.component.html'
        });

    /* @ngInject */
    function userOrganizationController($q, userOrganizationService) {
        var vm = this;
        vm.$onInit = onInit;

        vm.locations = [];       
        vm.location = {
            LocationId: null,
            Label: '',
            Address: {
                CustomerId: null,
                Name: '',
                Address1: '',
                Address2: '',
                City: '',
                StateCode: '',
                ZipCode: '',
                CountryCode: ''
            },
            Zoom: 17,
            Center: { lat: 15, lng: 15}
        };

        vm.onChange = onChange;
        vm.autoCompleteAddress = autoCompleteAddress;
        vm.geoCodeAddress = geoCodeAddress;

        function onInit() {
            if (vm.existingModel) {
                var existingAddressModel = _.omit(vm.existingModel, ['CustomerId', 'Name']);
                var existingModelKeys = _.keys(existingAddressModel);
                vm.existingModel = angular.extend(vm.existingModel, { Label: '' });

                _.each(existingModelKeys, function (key) {                    
                    vm.existingModel.Label = buildLocationLabel(vm.existingModel.Label, vm.existingModel[key]);
                });
                
            }

            if (vm.model) {
                vm.location.Label = null;

                var addressModel = _.omit(vm.model, ['CustomerId', 'Name']);
                var modelKeys = _.keys(addressModel);

                _.each(modelKeys, function (key) {
                    vm.location.Address = angular.extend(vm.location.Address, extendAddress(vm.model));
                    vm.location.Label = buildLocationLabel(vm.location.Label, vm.model[key]);
                });

                geoCodeAddress(vm.location.Label, false);
            }
        }

        function extendAddress(address) {
            return {
                CustomerId: address.CustomerId,
                Name: address.Name,
                Address1: address.Address1,
                Address2: address.Address2,
                City: address.City,
                StateCode: address.StateCode,
                ZipCode: address.ZipCode,
                CountryCode: address.CountryCode
            };
        }

        function buildLocationLabel(currentLabel, newValue) {
            if (!newValue) {
                return currentLabel;
            }
            return currentLabel ? currentLabel + ', ' + newValue : newValue;
        }

        function geoCodeAddress(searchText, hasLocationId) {
            if (!searchText) { return; }

            if (hasLocationId) {
                return userOrganizationService.geoCodeByLocationId(searchText)
                    .then(function (result) {                    
                    if (result.status === 200 && result.data.items && result.data.items.length > 0) {
                        vm.location.Center = {
                            lat: result.data.items[0].position.lat,
                            lng: result.data.items[0].position.lng
                        };
                    }
                });
            } else {
                return userOrganizationService.geoCodeByAddress(searchText).then(function (result) {                    
                    if (result.status === 200 && result.data.items && result.data.items.length > 0) {
                        vm.location.Center = {
                            lat: result.data.items[0].position.lat,
                            lng: result.data.items[0].position.lng
                        };
                    }                    
                });
            }            
        }

        function autoCompleteAddress(searchValue) {
            if (!searchValue) { return; }

            return userOrganizationService.autocompleteAddressSearch(searchValue).then(function (result) {
                ATAC.hideLoader();
                if (result.status === 200 && result.data.items && result.data.items.length > 0) {
                    return result.data.items.map(function (item) {
                        return {
                            LocationId: item.id,
                            Label: item.address.label,
                            Address: {
                                Address1: item.address.houseNumber ? item.address.houseNumber + ' ' +
                                    item.address.street : item.address.street,
                                Address2: '',
                                City: item.address.city,
                                StateCode: item.address.stateCode || item.address.state,
                                ZipCode: item.address.postalCode,
                                CountryCode: item.address.countryCode
                            },
                            Zoom: 17
                        };
                    });
                }
            });
        }

        function onChange(model) {
            vm.onAddressChanged({ address: model.Address });

            var extendedAddress = angular.extend(vm.location.Address, model.Address);

            vm.location = model;
            vm.location.Address = extendedAddress;

            geoCodeAddress(model.LocationId, true);
        }
    }
})();
